import {
  IconStatusErrorColor,
  IconStatusFailedFill,
  IconStatusPassedFill,
  IconStatusQueuedFill,
  IconStatusRunningFill,
} from '@saucelabs/ds-icons';
import React from 'react';
import classnames from 'classnames';

import { FilterBarState, FilterItem, OwnerType } from './types';
import { types } from '../../../../web-ui-jobs/src/ducks/filterBar';
import { BuildStatus } from '../../graphql/__generated__/graphql';

export const VISUAL_SLICE_NAME = 'visual/filterBar';

export const OWNER_TYPES: OwnerType[] = [
  'organization',
  'user',
  'team',
];

const BASE_ICON_CLASS = 'w-2 h-2 mr-1 fill-current';

export const STATUSES: FilterItem<BuildStatus>[] = [
  {
    key: BuildStatus.Approved,
    label: 'Accepted',
    prefixIcon: <IconStatusPassedFill className={classnames(BASE_ICON_CLASS, 'text-green-600')} />,
  },
  {
    key: BuildStatus.Equal,
    label: 'No Changes',
    prefixIcon: <IconStatusPassedFill className={classnames(BASE_ICON_CLASS, 'text-green-600')} />,
  },
  {
    key: BuildStatus.Running,
    label: 'Running',
    prefixIcon: <IconStatusRunningFill className={classnames(BASE_ICON_CLASS, 'text-blue-800')} />,
  },
  {
    key: BuildStatus.Queued,
    label: 'Queued',
    prefixIcon: <IconStatusQueuedFill className={classnames(BASE_ICON_CLASS, 'text-gray-600')} />,
  },
  {
    key: BuildStatus.Unapproved,
    label: 'For Review',
    prefixIcon: <IconStatusQueuedFill className={classnames(BASE_ICON_CLASS, 'text-orange-600')} />,
  },
  {
    key: BuildStatus.Errored,
    label: 'Errored',
    prefixIcon: <IconStatusErrorColor className={classnames(BASE_ICON_CLASS, 'text-orange-600')} />,
  },
  {
    key: BuildStatus.Rejected,
    label: 'Rejected',
    prefixIcon: <IconStatusFailedFill className={classnames(BASE_ICON_CLASS, 'text-red-900')} />,
  },
];

export const pageDefault = 1;

export const getInitialState = (): FilterBarState => ({
  init: 'idle',
  date: {
    start: types.RelativeDateRanges.last7Days,
    end: '',
  },
  owner: {
    items: [],
    loading: false,
    value: null,
    type: null,
    label: '',
    searchValue: null,
  },
  buildName: {
    value: '',
    searchValue: null,
  },
  status: {
    value: [],
  },
  project: {
    value: null,
    searchValue: null,
  },
  branch: {
    value: null,
    searchValue: null,
  },
  page: {
    value: pageDefault,
  },
});
